export function debounce<F extends (
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    ...args: any[]) => void>(
    fn: (this: ThisParameterType<F>, ...args: Parameters<F>) => void,
    delay: number
): (...args: Parameters<F>) => void {
    let timeout: NodeJS.Timeout | null = null;

    return function (this: ThisParameterType<F>, ...args: Parameters<F>) {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(
            () => {
                fn.apply(
                    this,
                    args
                );
            },
            delay
        );
    };
}
